import React from "react";
import { Text } from "react-native";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { router } from "expo-router";

import UnlockUsersBaseCard from "../../Base/UnlockUsersBaseCard";

import { ProfileCompletionScore } from "@/utils/unlockingStage";
import UserAvatar from "@/Components/Media/User/Images/UserAvatar";
import { UserImageMedia } from "@/schemas/user/image";

type Props = {
  avatar: UserImageMedia | null;
  onAction: () => void;
};

function UnlockUsersAvatarCard({ avatar, onAction }: Props): React.JSX.Element {
  return (
    <UnlockUsersBaseCard
      iconComponent={
        avatar ? (
          <UserAvatar avatar={avatar} defaultAvatarColor={"black"} size={36} />
        ) : (
          <MaterialCommunityIcons
            name="face-man-outline"
            size={36}
            color="black"
          />
        )
      }
      title="Profile Photo"
      description="Upload a clear photo of yourself"
      totalScore={ProfileCompletionScore.AVATAR}
      statusComponent={<Text>{avatar ? "Completed" : "Not Completed"}</Text>}
      isCompleted={avatar ? true : false}
      onPressActionButton={() => {
        onAction();
        router.push("/(main)/account/home");
      }}
    />
  );
}

export default UnlockUsersAvatarCard;
